// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicy_page__UgBd0","content":"PrivacyPolicy_content__55j3x","header":"PrivacyPolicy_header__uWNNN","box":"PrivacyPolicy_box__1G9AV"};